import React, { useCallback, useMemo, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import RegisterForm from 'components/RegisterForm/RegisterForm';
import { register } from 'services/auth.service';
import { withAuthLayout } from 'layouts/AuthLayout/AuthLayout';
import { useAlert } from 'context/AlertProvider';

function RegisterPage() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const alert = useAlert();

  const messages = useMemo(
    () => ({
      InvalidParameterException:
        'Por favor, revisa que tanto email y/o la contraseña.<br /><small>El <strong>e-mail</strong> debe ser válido y pertener a @cecotec.es.<br />La <strong>contraseña</strong> debe tener una longitud de 8 caracteres e incluir minúsculas, mayúsculas y caracteres especiales.</small>',
      InvalidCecotecEmailError:
        'Solo pueden registrarse cuentas con email @cecotec.es',
    }),
    [],
  );

  const submitHandler = useCallback(
    async (email, password) => {
      try {
        setLoading(true);
        await register(email, password);
        alert.current.message('Usuario registrado con éxito', () =>
          history.push('/login'),
        );
      } catch (error) {
        console.error({ error });
        alert.current.error(
          messages[error.code] ??
            'No se ha podido completar el proceso de registro correctamente',
        );
        setLoading(false);
      }
    },
    [history, messages, alert],
  );

  return (
    <>
      <h1>Registro</h1>
      <RegisterForm loading={loading} onSubmit={submitHandler} />
      <footer className="auth-layout__footer">
        <Link to="/login">Volver</Link>
      </footer>
    </>
  );
}

export default withAuthLayout(RegisterPage);
